<ts-page [sidenavConfig]="savedViewsSidebarConfig">
  <app-saved-view-sidebar sidenav [relatedToType]="relatedToType.Property" />
  <router-outlet main></router-outlet>
</ts-page>
